import { FormatConstants } from "services/keyConstants";
import { showToast } from "services/utils";

export const getDefaultData = (columnData, options = {}) => {
  const userData = options?.userData || {};
  const defaultRows = {};

  columnData?.forEach((item) => {
    const field = item?.uniqueName; 

    if (!field) return;

    switch (field) {
      case "customerName":
        defaultRows[field] = userData?.name || "";
        break;

      case "customerEmail":
        defaultRows[field] = userData?.email || "";
        break;

      case "customerMobile":
        defaultRows[field] = userData?.phone || "";
        break;

      case "gstNumber":
      case "billingAddress":
      case "shippingAddress":
        defaultRows[field] = userData?.customerDetails?.[field] || "";
        break;

      case "isSameShippingAddress":
        defaultRows[field] =
          JSON.stringify(userData?.customerDetails?.billingAddress) ===
          JSON.stringify(userData?.customerDetails?.shippingAddress);
        break;

      default:
        defaultRows[field] = "";
    }
  });

  return defaultRows;
};

export const getStatusTypes = (type) => {
  switch (type) {
    case FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION.ORDER_FORM:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          orderStatus: "",
          status: "",
          revisionNumber: "",
          documentName: FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION.ORDER_FORM
        },
        defaultOptionData: {
          statusOptions: [
            {
              label: "Pending From Customer Side",
              value: "Pending From Customer Side",
            },
            { label: "Waiting For Approval", value: "Waiting For Approval" },
            {
              label: "Pending For Allocation",
              value: "Pending For Allocation",
            },
            { label: "Completed", value: "Completed" },
            { label: "Rejected", value: "Rejected" },

            { label: "Initiated", value: "Initiated" },
            { label: "Pending", value: "pending" },
            { label: "Pending For Approval", value: "Pending For Approval" },
            { label: "Review", value: "review" },
          ],
        },
      };
      break;

    case FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION
      .ORDER_REVIEW_FORM:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          orderStatus: "",
          status: "",
          revisionNumber: "",
          documentName: FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION.ORDER_REVIEW_FORM
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Initiated", value: "Initiated" },
            { label: "Rejected", value: "Rejected" },
            { label: "Accepted", value: "Accepted" },
            { label: "Request For Modified", value: "Request For Modified" },
            { label: "Pending", value: "Pending" },
          ],
        },
      };
      break;

    // Add more cases as needed
    case FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION
      .DISTRIBUTION_RECORD:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          orderStatus: "",
          status: "",
          revisionNumber: "",
          documentName: FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION.DISTRIBUTION_RECORD,
          // orderStatus: "Pending",
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Initiated", value: "Initiated" },
            { label: "Product Allocated", value: "Product Allocated" },
            { label: "Product Partially", value: "Product Partially" },
            { label: "Product Not Allocated", value: "Product Not Allocated" },
          ],
        },
      };
      break;

    case FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION
      .DISTRIBUTOR_FORM:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          status: "",
          documentName:
            FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION
              .DISTRIBUTOR_FORM,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Initiated", value: "Initiated" },
            { label: "Waiting for review", value: "Waiting for review" },
            { label: "Approved", value: "Approved" },
            { label: "Request For Modified", value: "Request For Modified" },
            { label: "Rejected", value: "Rejected" },
          ],
        },
      };
      break;

    case FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION
      .DISTRIBUTOR_AGREEMENT:
      return {
        filteredData: {
          currentPage: 1,
          totalPage: 1,
          status: "",
          documentName:
            FormatConstants.CUSTOMER_RELATED_PROCESS_AND_DISTRIBUTION
              .DISTRIBUTOR_AGREEMENT,
          revisionNumber: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Waiting for Agreement", value: "Waiting for Agreement" },
            { label: "Waiting for review", value: "Waiting for review" },
            { label: "Request for Modify", value: "Request for Modify" },
            { label: "Waiting for Document", value: "Waiting for Document" },
            {
              label: "Waiting for Document Approver",
              value: "Waiting for Document Approver",
            },
            { label: "Document Approved", value: "Document Approved" },
          ],
        },
      };
      break;

    // Default case if no matching type is found
    default:
      return {
        filteredData: {
          orderStatus: "Unknown",
          status: "Unknown",
          documentName: "Unknown Document",
        },
        defaultOptionData: {
          statusOptions: [],
        },
      };
  }
};

export const handleFileUpload = (
  event,
  productRowsState,
  setProductRowsState,
  productColumnData
) => {
  const file = event?.target?.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const text = e?.target?.result;
    const rows = text?.split("\n")?.map((row) => row?.split(",")); // Parse CSV into array

    if (!rows || rows.length < 4) {
      console.error("Invalid CSV structure.");
      return;
    }

    // Extract headers from the 3rd row (index 2)
    const headers = rows[2]?.map((header) => header.replace(/"/g, "").trim());
    const dataRows = rows.slice(3);

    const updatedData = [...productRowsState];

    const quantityColumnIndex = headers.findIndex((h) => h === "Quantity");
    const productDetailsColumnIndex = headers.findIndex(
      (h) => h === "Product Details"
    );

    if (quantityColumnIndex === -1 || productDetailsColumnIndex === -1) {
      console.error("Required columns not found in the uploaded file.");
      return;
    }

    dataRows.forEach((row) => {
      const productDetails = row[productDetailsColumnIndex]
        ?.replace(/"/g, "")
        .trim();
      let quantity =
        parseInt(row[quantityColumnIndex]?.replace(/"/g, "").trim()) || 0;

      const index = updatedData.findIndex(
        (item) => item.productDetails === productDetails
      );

      if (index !== -1) {
        if (quantity < 0) {
          console.warn(
            `Negative quantity for "${productDetails}", setting to 0.`
          );
          quantity = 0;
        }

        updatedData[index] = {
          ...updatedData[index],
          quantity,
          checked: quantity > 0,
          select: quantity > 0,
        };
      }
    });

    setProductRowsState(updatedData);
    showToast("File Uploaded Successfully", true);
  };

  reader.readAsText(file);
};

export const downloadCSV = (productRowsState, productColumnData) => {
  if (!productColumnData?.columns || !productRowsState) return;

  // Only include 'productDetails' and 'quantity'
  const filteredColumns = productColumnData.columns.filter((col) =>
    ["productDetails", "quantity"].includes(col.uniqueName)
  );

  const headers = filteredColumns.map((col) => col.name);

  const staticRow = `"Specify the Order Quantity",${Array(headers.length - 1)
    .fill('""')
    .join(",")}`;
  const blankRow = Array(headers.length).fill('""').join(",");
  const headerRow = headers.join(",");

  const rows = productRowsState.map((row) => {
    const values = filteredColumns.map((col) => {
      const key = col.uniqueName;

      if (key === "quantity") {
        return `"${row[key] !== "" ? row[key] : 0}"`;
      }

      if (key === "productDetails") {
        return `"${row[key] || ""}"`;
      }

      return '""'; // Default fallback
    });

    return values.join(",");
  });

  const csvContent = [staticRow, blankRow, headerRow, ...rows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "Product_Details.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const updateFirstArrayWithInputValues = (tableName, rowData) => {
  const nameToDocKey = {
    "Distributor Details": "distributorTable",
    "Contact Person Information": "contactTable",
    "Business Details": "bussinessTable",
    "Products And Manufacturer": "productAndManufacturerTable",
    Explanation: "explanationTable",
    "Distribution Products": "distributionProducts",
    "Payment Information": "paymentTable",
    Infrastructure: "infrastructureTable",
    Other: "otherTable",
    Remarks: "remarkTable",
    "Company Details": "companyDetailsTable",
    "Distribution Products": "productTable",
  };

  const docKey = nameToDocKey[tableName];
  if (!docKey) {
    console.warn(`No matching docKey found for tableName: "${tableName}"`);
    return {};
  }

  return {
    [docKey]: {
      rows: rowData || {}, // safely handle null/undefined rowData
    },
  };
};
